/** MFE built-in Tone target dial number, used locally to suppress network-test call UI. */
export const DEFAULT_NETWORK_TEST_NUMBER = '5555555551';
